import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingCosts } from './types/Listing';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingCosts>('GET', `${APIV2_URL}/listing/${listingId}/costs`);
